var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Merhaba"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_vm._v(" BODO BODE içerik yönetim sistemine hoşgeldiniz. "),_c('div',{staticClass:"text-muted font-small-2"},[_vm._v(" CODE64 CMS ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }